module.exports = __webpack_public_path__ + "media/font/summernote-6587bce4.ttf";